import {BaseApi} from '@/common/api/BaseApi';
import {ApiProperties} from '@/types/common/api/api.types';

export class MaintenanceApi {

  public static api({id, version = 'v1'}: ApiProperties = {}): string {
    return `${BaseApi.ROOT_URL}/api/${version}/maintenance${id !== undefined ? `/${id}` : ''}`;
  }

  public static current({version = 'v1'}: Pick<ApiProperties, 'version'> = {}): string {
    return `${BaseApi.ROOT_URL}/api/${version}/maintenance/current`;
  }

  public static activate({id, version = 'v1'}: ApiProperties): string {
    return `${BaseApi.ROOT_URL}/api/${version}/maintenance/${id}/activate`;
  }

  public static end({id, version = 'v1'}: ApiProperties): string {
    return `${BaseApi.ROOT_URL}/api/${version}/maintenance/${id}/end`;
  }

  // Wartungs-AUFGABEN liegen unter einem eigenen Prefix, nicht unter
  // /maintenance/... — dort hätten die `:id`-Routen der Wartungsfenster den
  // Unterpfad abgefangen.
  public static videoMetadataBackfill({version = 'v1'}: Pick<ApiProperties, 'version'> = {}): string {
    return `${BaseApi.ROOT_URL}/api/${version}/maintenance-task/video-metadata-backfill`;
  }

  public static customerStyleBackfill({version = 'v1'}: Pick<ApiProperties, 'version'> = {}): string {
    return `${BaseApi.ROOT_URL}/api/${version}/maintenance-task/customer-style-backfill`;
  }
}
